/** A duration for a label: sub-minute values keep a decimal, minutes carry their seconds. */
export const formatDuration = (ms: number): string => {
  const tenths = Math.round(Math.max(0, ms) / 100) / 10;
  if (tenths === 0) return '0s';
  if (tenths < 60) return `${tenths.toFixed(1)}s`;
  const whole = Math.round(tenths);
  const minutes = Math.floor(whole / 60);
  const seconds = whole % 60;
  return seconds === 0 ? `${minutes}m` : `${minutes}m ${seconds}s`;
};
